import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MealComponent } from "./meal-component/meal-component.component";
import { MealStylePipe } from "./meal-style.pipe";
import { MealOptionComponent } from "./meal-option/meal-option.component";

@NgModule({
  declarations: [MealComponent, MealStylePipe, MealOptionComponent],
  imports: [CommonModule],
  exports: [MealComponent],
  entryComponents: [MealComponent, MealOptionComponent]
})
export class MealModule {}
